import { useLinkTo } from '@react-navigation/native'
import { Box, HStack, Icon, Text, Button } from 'native-base'
import { Info } from 'phosphor-react-native'
import React from 'react'
import { Trans } from 'react-i18next'

import { RootStackParamList } from '../../navigation'

export const BlockedUserAlert = () => {
  const linkTo = useLinkTo<RootStackParamList>()

  return (
    <Box bg="primary.100" borderRadius="lg" px="4" py="3">
      <HStack justifyContent="space-between" alignItems="center" space={'md'}>
        <Icon as={<Info color="currentColor" />} size="lg" color="primary.500" />
        <Box flex={1}>
          <Text>
            <Trans i18nKey="screens.welcome.registrationOrientation.blockedUser">
              <Button size={'sm'} onPress={() => linkTo('/support')} variant="link" p={0} m={0} />
            </Trans>
          </Text>
        </Box>
      </HStack>
    </Box>
  )
}
